import { Component } from '@angular/core';

@Component({
  selector: 'app-partial-order',
  templateUrl: './partial-order.component.html',
  styleUrls: ['./partial-order.component.scss']
})
export class PartialOrderComponent {

}
